import React, { useState, useEffect } from 'react';
import './GestionMessages.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';
import { contactService } from '../../services/contactService';

function GestionMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState('tous');
  const [replyData, setReplyData] = useState({
    subject: '',
    message: ''
  });
  const [sendingReply, setSendingReply] = useState(false);

  useEffect(() => {
    loadMessages();
  }, []);

  const loadMessages = async () => {
    try {
      setLoading(true);
      const response = await contactService.getAll();
      console.log('Response complète:', response);
      console.log('response.data:', response.data);
      console.log('Type de response.data:', Array.isArray(response.data));
      
      const data = Array.isArray(response.data) ? response.data : 
                   (response.data && Array.isArray(response.data.data)) ? response.data.data : 
                   (response && Array.isArray(response)) ? response : [];
      
      console.log('Messages extraits:', data);
      setMessages(data);
    } catch (error) {
      console.error('Erreur lors du chargement des messages:', error);
      setMessages([]);
    } finally {
      setLoading(false);
    }
  };

  const handleViewMessage = (message) => {
    setSelectedMessage(message);
    setShowModal(true);
    // Marquer comme lu si non lu
    if (message.statut === 'nouveau') {
      markAsRead(message.id);
    }
  };

  const handleReply = (message) => {
    setSelectedMessage(message);
    setReplyData({
      subject: `Re: ${message.sujet || 'Votre message'}`,
      message: ''
    });
    setShowReplyModal(true);
  };

  const handleSendReply = async () => {
    if (!replyData.message.trim()) {
      alert('Veuillez écrire un message');
      return;
    }

    try {
      setSendingReply(true);
      console.log('📧 Envoi de la réponse...', {
        contact_id: selectedMessage.id,
        to_email: selectedMessage.email,
        to_name: `${selectedMessage.nom} ${selectedMessage.prenom}`,
        subject: replyData.subject
      });

      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/contacts/reply', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contact_id: selectedMessage.id,
          to_email: selectedMessage.email,
          to_name: `${selectedMessage.nom} ${selectedMessage.prenom}`,
          subject: replyData.subject,
          message: replyData.message
        })
      });

      const data = await response.json();
      console.log('📬 Réponse du serveur:', data);

      if (response.ok) {
        alert('Réponse envoyée avec succès!');
        setShowReplyModal(false);
        setReplyData({ subject: '', message: '' });
        // Marquer le message comme traité
        await contactService.updateStatut(selectedMessage.id, 'traite');
        loadMessages();
      } else {
        console.error('❌ Erreur serveur:', data);
        throw new Error(data.message || 'Erreur lors de l\'envoi');
      }
    } catch (error) {
      console.error('❌ Erreur lors de l\'envoi de la réponse:', error);
      alert(`Erreur lors de l'envoi de la réponse: ${error.message}`);
    } finally {
      setSendingReply(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      await contactService.markAsRead(id);
      setMessages(messages.map(msg => 
        msg.id === id ? { ...msg, statut: 'lu' } : msg
      ));
    } catch (error) {
      console.error('Erreur lors du marquage comme lu:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce message ?')) {
      try {
        await contactService.delete(id);
        setMessages(messages.filter(msg => msg.id !== id));
        setShowModal(false);
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
        alert('Erreur lors de la suppression du message');
      }
    }
  };

  const filteredMessages = filterStatus === 'tous' 
    ? messages 
    : filterStatus === 'non-lus'
    ? messages.filter(msg => msg.statut === 'nouveau')
    : messages.filter(msg => msg.statut === 'lu' || msg.statut === 'traite');

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Messages & Contacts" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="breadcrumb-section" style={{display: 'none'}}>
            <h1>Messages & Contacts</h1>
            <div className="breadcrumb">
              <span>🏠 Accueil › Messages</span>
            </div>
          </div>

          <div className="messages-header">
            <div className="filter-tabs">
              <button 
                className={`filter-tab ${filterStatus === 'tous' ? 'active' : ''}`}
                onClick={() => setFilterStatus('tous')}
              >
                Tous ({messages.length})
              </button>
              <button 
                className={`filter-tab ${filterStatus === 'non-lus' ? 'active' : ''}`}
                onClick={() => setFilterStatus('non-lus')}
              >
                Non lus ({messages.filter(m => m.statut === 'nouveau').length})
              </button>
              <button 
                className={`filter-tab ${filterStatus === 'lus' ? 'active' : ''}`}
                onClick={() => setFilterStatus('lus')}
              >
                Lus ({messages.filter(m => m.statut === 'lu' || m.statut === 'traite').length})
              </button>
            </div>
            <button className="refresh-btn" onClick={loadMessages}>
              🔄 Actualiser
            </button>
          </div>

          {loading ? (
            <div className="loading-state">Chargement des messages...</div>
          ) : filteredMessages.length === 0 ? (
            <div className="empty-state">
              <p>📭 Aucun message pour le moment</p>
            </div>
          ) : (
            <div className="messages-list">
              {filteredMessages.map((message) => (
                <div 
                  key={message.id} 
                  className={`message-item ${message.statut === 'nouveau' ? 'unread' : ''}`}
                  onClick={() => handleViewMessage(message)}
                >
                  <div className="message-indicator">
                    {message.statut === 'nouveau' && <span className="unread-dot"></span>}
                  </div>
                  <div className="message-content">
                    <div className="message-header-row">
                      <h3>{message.nom} {message.prenom}</h3>
                      <span className="message-date">{formatDate(message.created_at)}</span>
                    </div>
                    <p className="message-subject">{message.sujet || 'Sans sujet'}</p>
                    <p className="message-preview">{message.message?.substring(0, 100)}...</p>
                    <div className="message-meta">
                      <span>📧 {message.email}</span>
                      {message.telephone && <span>📞 {message.telephone}</span>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {showModal && selectedMessage && (
            <div className="modal-overlay" onClick={() => setShowModal(false)}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h2>Message de {selectedMessage.nom} {selectedMessage.prenom}</h2>
                  <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
                </div>
                <div className="modal-body">
                  <div className="message-details">
                    <div className="detail-row">
                      <strong>Email:</strong>
                      <a href={`mailto:${selectedMessage.email}`}>{selectedMessage.email}</a>
                    </div>
                    {selectedMessage.telephone && (
                      <div className="detail-row">
                        <strong>Téléphone:</strong>
                        <a href={`tel:${selectedMessage.telephone}`}>{selectedMessage.telephone}</a>
                      </div>
                    )}
                    <div className="detail-row">
                      <strong>Sujet:</strong>
                      <span>{selectedMessage.sujet || 'Sans sujet'}</span>
                    </div>
                    <div className="detail-row">
                      <strong>Date:</strong>
                      <span>{formatDate(selectedMessage.created_at)}</span>
                    </div>
                  </div>
                  <div className="message-body">
                    <strong>Message:</strong>
                    <p>{selectedMessage.message}</p>
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    className="btn-reply"
                    onClick={() => {
                      setShowModal(false);
                      handleReply(selectedMessage);
                    }}
                  >
                    ✉️ Répondre
                  </button>
                  <button 
                    className="btn-delete"
                    onClick={() => handleDelete(selectedMessage.id)}
                  >
                    🗑️ Supprimer
                  </button>
                </div>
              </div>
            </div>
          )}

          {showReplyModal && selectedMessage && (
            <div className="modal-overlay" onClick={() => setShowReplyModal(false)}>
              <div className="modal-content reply-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h2>Répondre à {selectedMessage.nom} {selectedMessage.prenom}</h2>
                  <button className="close-btn" onClick={() => setShowReplyModal(false)}>×</button>
                </div>
                <div className="modal-body">
                  <div className="reply-to-info">
                    <strong>À:</strong> {selectedMessage.email}
                  </div>
                  
                  <div className="form-group">
                    <label>Sujet:</label>
                    <input
                      type="text"
                      value={replyData.subject}
                      onChange={(e) => setReplyData({ ...replyData, subject: e.target.value })}
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label>Message:</label>
                    <textarea
                      value={replyData.message}
                      onChange={(e) => setReplyData({ ...replyData, message: e.target.value })}
                      rows="10"
                      className="form-textarea"
                      placeholder="Écrivez votre réponse ici..."
                    />
                  </div>

                  <div className="original-message">
                    <strong>Message original:</strong>
                    <p>{selectedMessage.message}</p>
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    className="btn-cancel"
                    onClick={() => setShowReplyModal(false)}
                    disabled={sendingReply}
                  >
                    Annuler
                  </button>
                  <button 
                    className="btn-send"
                    onClick={handleSendReply}
                    disabled={sendingReply}
                  >
                    {sendingReply ? 'Envoi en cours...' : '📧 Envoyer'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default GestionMessages;
